<h3>Seção de Destaques</h3>
<form class="form-b4a" [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="highlights-section">
    <h4>Highlights</h4>
    <div
      formArrayName="highlights"
      cdkDropList
      (cdkDropListDropped)="onDrop($event)"
    >
      <div
        *ngFor="let highlight of highlights.controls; let i = index"
        [formGroupName]="i"
        class="highlight-item p-card"
        cdkDrag
      >
        <div class="highlight-content">
          <span class="p-float-label">
            <input
              type="text"
              pInputText
              formControlName="title"
              id="title{{ i }}"
              name="title"
            />
            <label for="title{{ i }}">Título *</label>
          </span>
          <span class="p-float-label">
            <input
              type="text"
              pInputText
              formControlName="subtitle"
              id="subtitle{{ i }}"
              name="subtitle"
            />
            <label for="subtitle{{ i }}">Subtítulo *</label>
          </span>

          <span class="image-upload">
            <div class="file-upload">
              <span class="p-float-label">
                <input
                  type="text"
                  readonly
                  pInputText
                  formControlName="image"
                  id="image{{ i }}"
                />
                <label for="image{{ i }}">
                  Imagem * - (Máx. 250kb / SVG, WEBP, ICO)
                </label>
              </span>
              <p-fileUpload
                mode="basic"
                chooseLabel="Selecionar"
                name="file"
                [auto]="true"
                [accept]="highlightImageAccept"
                [maxFileSize]="250 * 1024"
                uploadIcon="pi pi-file"
                [customUpload]="true"
                (uploadHandler)="
                  onUpload(
                    $event,
                    'highlights.' + i + '.image',
                    desktopUpload,
                    undefined,
                    false,
                    highlightWidth,
                    highlightHeight
                  )
                "
                id="image{{ i }}"
                #desktopUpload
              />
            </div>
            <img
              class="highlight-image-preview"
              *ngIf="form.value.highlights[i].image"
              [src]="form.value.highlights[i].image"
            />
          </span>

          <span class="p-float-label">
            <input
              type="text"
              pInputText
              formControlName="altText"
              id="altText{{ i }}"
              name="altText"
            />
            <label for="altText{{ i }}">Alt Text *</label>
          </span>
          <span class="p-float-label">
            <input
              type="url"
              pInputText
              formControlName="link"
              id="link{{ i }}"
              name="link"
            />
            <label for="link{{ i }}">Link *</label>
          </span>
          <span class="p-input-checkbox">
            <p-checkbox
              formControlName="highlighted"
              [binary]="true"
              inputId="highlighted{{ i }}"
            />
            <label for="highlighted{{ i }}">Highlighted</label>
          </span>
          <span
            class="p-input-checkbox"
            *ngIf="form.value.highlights[i].starred"
          >
            <p-checkbox
              formControlName="starred"
              [binary]="true"
              inputId="starred{{ i }}"
              [checked]="true"
              [readonly]="true"
            />
            <label for="starred{{ i }}">Starred</label>
          </span>

          <div
            class="w-full"
            style="grid-column: 1 / -1"
            *ngIf="!form.value.highlights[i].starred"
          >
            <h4>Regras de Exibição</h4>
            <div
              class="displayRules"
              formGroupName="displayRules"
              style="
                display: grid;
                grid-template-columns: repeat(5, 1fr);
                gap: 10px;
              "
            >
              <div class="rule-group">
                <label>Assinante já comprou</label>
                <p-dropdown
                  formControlName="subscriberBuyer"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="rule-group">
                <label>Não assinante</label>
                <p-dropdown
                  formControlName="notSubscriber"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="rule-group">
                <label>Assinante nunca comprou</label>
                <p-dropdown
                  formControlName="subscriberNotBuyer"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="rule-group">
                <label>Assinante top badge</label>
                <p-dropdown
                  formControlName="topBadgeSubscriber"
                  [options]="displayRuleOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione"
                  appendTo="body"
                ></p-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div class="highlight-actions">
          <p-button
            type="button"
            icon="pi pi-arrows-alt"
            class="p-button-text p-button-rounded"
            pTooltip="Arrastar para reordenar"
            cdkDragHandle
          />
          <p-button
            *ngIf="!form.value.highlights[i].starred"
            type="button"
            icon="pi pi-trash"
            severity="danger"
            (click)="removeHighlight(i)"
            class="p-button-sm remove-button"
          />
        </div>
      </div>
    </div>
    <p-button
      type="button"
      label="Adicionar Highlight"
      icon="pi pi-plus"
      (click)="addHighlight()"
      class="p-button-secondary"
    />
  </div>

  <span class="buttons">
    <p-button
      label="Voltar"
      severity="danger"
      routerLink="/configuracoes/mens/home"
    />
    <p-button label="Salvar" type="submit" [disabled]="!form.valid" />
  </span>
</form>
